import {first} from 'lodash';
import {connect} from 'react-redux';

import {makeGetTicketStatus} from '../../../../../../libs/inboxes/store/src/ticketing/ticketStatusSelectors';
import {getTimeFormat} from '../../../../../../libs/shared/core/src/store/data/preferences/commonPreferencesSelectors';
import {createSelector, makeMapStateToProps} from '../../../../../../srcCommon/helpers/reselectHelpers';
import {
  StaticViewerActivity,
  StaticViewerActivityTypesEnum,
} from '../../../../../../srcCommon/inboxes/viewer/activity/static/staticViewerHelpers';
import {makeGetStaticViewerActivityDetails} from '../../../../../../srcCommon/inboxes/viewer/activity/static/staticViewerSelectors';
import {ActivitySourceVisualTypesEnum} from '../../../../../models/api/activitySourceModel';
import {ConversationModel} from '../../../../../models/api/conversationModel';
import {ReminderModel} from '../../../../../models/api/reminderModel';
import {makeGetTeamInboxes} from '../../../../../store/data/conversations/conversationsSelectors';
import {makeGetTeamInboxCellsContext} from '../../../../../store/panels/cells/context/cellsContextSelectors';
import {StaticViewer} from './staticViewer';

/*
 * Props.
 */

interface StaticViewerContainerProps {
  conversation: ConversationModel;
  staticViewerActivity: StaticViewerActivity;
}

/*
 * Selectors.
 */

function getConversation(_state: unknown, props: StaticViewerContainerProps) {
  return props.conversation;
}

function getStaticViewerActivity(_state: unknown, props: StaticViewerContainerProps) {
  return props.staticViewerActivity;
}

function makeGetTeamReminder() {
  return createSelector(
    [getStaticViewerActivity, getConversation],
    (staticViewerActivity, conversation): ReminderModel | undefined => {
      if (
        staticViewerActivity.type !== StaticViewerActivityTypesEnum.REMINDER ||
        staticViewerActivity.activity?.source.visualType !== ActivitySourceVisualTypesEnum.TEAMMATE
      ) {
        return undefined;
      }

      const activitySourceTeammateId = staticViewerActivity.activity.source.teammateId;
      // Find the matching team reminder
      return conversation.reminders.find(
        (r) => r.isTeamReminder && r.teammateId === activitySourceTeammateId,
      );
    },
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<StaticViewerContainerProps>()(() => {
  const getTeamInboxes = makeGetTeamInboxes(getConversation);
  const getTeamCellsContext = makeGetTeamInboxCellsContext<StaticViewerContainerProps>(
    (state, props) => first(getTeamInboxes(state, props))?.id,
  );

  return {
    teamCellsContext: getTeamCellsContext,
    ticketStatus: makeGetTicketStatus(getTeamCellsContext, getConversation),
    teamInboxes: getTeamInboxes,
    teamReminder: makeGetTeamReminder(),
    timeFormat: getTimeFormat,
    staticViewerActivityDetails: makeGetStaticViewerActivityDetails(getStaticViewerActivity),
  };
});

export const StaticViewerContainer = connect(mapStateToProps)(StaticViewer);
